import { isEmpty } from "lodash";
import { handleActionBasedTabUpdate, updateTabDataWithoutAction } from "./message-type-table";
import { RENDER_MESSAGE_TYPE_CALENDAR } from "../../constants";


export const handleMessageTypeCalendar = (conversationId, message) => (dispatch, getState) => {
    const tabStack = getState().tabStack;

    if (tabStack && !isEmpty(tabStack)) {
        const tabStackData = tabStack?.[conversationId];
        let updatedTabStackData;

        if (message?.options?.action) {
            updatedTabStackData = handleActionBasedTabUpdate(
                tabStackData,
                message
            );
        } else {
            updatedTabStackData = updateTabDataWithoutAction(
                tabStackData,
                message,
                dispatch
            );
        }

        if (!message.options.updateInBackground) {
            updatedTabStackData = {
                ...updatedTabStackData,
                selectedTab: message?.options?.tabId,
            };
        }

        dispatch({
            type: RENDER_MESSAGE_TYPE_CALENDAR,
            data: { [conversationId]: updatedTabStackData },
        });
    } else {
        const data = {
            [conversationId]: {
                components: [message],
            },
        };

        if (!message.options.updateInBackground) {
            data[conversationId].selectedTab = message.options.tabId;
        }

        dispatch({
            type: RENDER_MESSAGE_TYPE_CALENDAR,
            data: data,
        });
    }
};